import { render, staticRenderFns } from "./ProfessionalProfessional.vue?vue&type=template&id=1976776c&scoped=true"
import script from "./ProfessionalProfessional.vue?vue&type=script&lang=js"
export * from "./ProfessionalProfessional.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalProfessional.vue?vue&type=style&index=0&id=1976776c&prod&scoped=true&lang=css"
import style1 from "./ProfessionalProfessional.vue?vue&type=style&index=1&id=1976776c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976776c",
  null
  
)

export default component.exports